<template>
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                    <v-icon left>mdi-hair-dryer-outline</v-icon>
                    Profissionais
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="paginationOptions.search"
                        class="mr-3"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        placeholder="Informe o Nome ou CPF do Profissional"
                        single-line
                        hide-details
                        @keydown="buscar()"
                        @click:append="buscar()"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-switch
                        v-model="bms.active"
                        :label=" `Exibindo ${bms.active? 'Ativos': 'Inativos'}`"
                        single-line
                        hide-details
                        class="mr-3"
                        style="width: 200px"
                        @change="buscar()"
                    ></v-switch>
                    <v-btn color="#3D1159" dark :to="{ name: 'bmCreate' }">
                        <v-icon left>mdi-plus</v-icon>
                        Adicionar
                    </v-btn>
                </v-card-title>
                <v-alert type="warning" outlined v-show="!bms"
                >Nenhum Profissional Encontrado
                </v-alert
                >
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="filteredBMsItems()"
                    :options.sync="options"
                    :server-items-length="bms.totalItems"
                    :search.sync="paginationOptions.search"
                    item-key="id"
                    class="elevation-1"
                    v-show="bms"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                      }"
                >
                    <template v-slot:item.assistant="{ item }">
                        <v-icon v-if="item.assistant">mdi-handshake-outline</v-icon>
                        <v-icon v-else>mdi-hair-dryer-outline</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">

                                <v-btn
                                    class="btn-lyndus"
                                    icon
                                    v-bind="attrs"

                                    v-on="on"
                                    :to="{
                                        name: 'bm',
                                        params: { id: item.id }
                                    }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>

                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";

import {
    BM_SEARCH,
    BMS_GET
    // BM_EDIT,
    // BM_CREATE,
    // BM_SEARCH,
} from "@/store/actions/bm.type";
import {BM_RESET_STATE, SET_BM_PAGINATION} from "@/store/mutations/bm.type";

export default {
    name: "ListarUsuarios",
    directives: {mask},
    props: {
        source: String
    },

    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.dispatch(BM_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            store.dispatch(BM_RESET_STATE),
            store.dispatch(BMS_GET)
        ]).then(() => {
            next();
        });
    },
    async beforeDestroy() {
        if(!this.$route.path.includes('/bms')){
            localStorage.removeItem('bmsOptions')
            localStorage.removeItem('bmPaginationOptions')
        }
    },
    data: () => ({
        //Lista de Usuários
        pagination: {
            sortBy: "name"
        },
        itemsPerPage: 1,

        selected: [],
        options: {},
        paginationOptions: {},
        headers: [
            {text: "", align: "center", value: "assistant"},
            {
                text: "Apelido",
                align: "left",
                value: "nickname"
            },
            {
                text: "Nome",
                align: "left",
                value: "name"
            },
            // { text: "Instituição", value: "instituicao" },
            {text: "CPF", value: "cpf"},
            {text: "Visualizar", align: "center", value: "actions", sortable: false}
        ],

        formIsValid: false,

        textRules: [
            v => !!v || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],

    }),
    methods: {
        //Methods Lista Usuarios
        toggleAll() {
            if (this.selected.length) this.selected = [];
            else this.selected = this.dados.slice();
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        buscar() {
            const {sortBy, sortDesc, itemsPerPage, page} = this.options
            this.bmPagination.search = this.paginationOptions.search

            store.commit(SET_BM_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0]
            })
            store.dispatch(BM_SEARCH);
        },
        filteredBMsItems() { 
            const items = this.bms.items
            const search = this.bmPagination.search ? this.bmPagination.search.toLowerCase() : ""
            if(search){
                this.options.itemsPerPage = this.bms.totalItems
                this.options.page = 1
                const exactMatches = [];
                const partialMatches = [];

                items.forEach(item => {
                    const itemValues = Object.values(item).map(value => String(value).toLowerCase());
                    const isExactMatch = itemValues.some(value => value.startsWith(search));
                    const isPartialMatch = itemValues.some(value => value.includes(search));
                    
                    if (isExactMatch) {
                        exactMatches.push(item);
                    } else if (isPartialMatch) {
                        partialMatches.push(item);
                    }
                });

                return [...exactMatches,...partialMatches];
            }
            else {
                if(this.options.itemsPerPage == this.bms.totalItems){
                    this.options.itemsPerPage = 10
                }
                return items;
            } 
        }

    },
    mounted() {
        if (localStorage.getItem('bmsOptions')){
            this.options = JSON.parse(localStorage.getItem('bmsOptions'))
        }
        if (localStorage.getItem('bmPaginationOptions')){
            this.paginationOptions = JSON.parse(localStorage.getItem('bmPaginationOptions'))
        }
    },
    watch: {
        options: {
            handler(newOptions) {
                this.buscar()
                const parsed = JSON.stringify(newOptions)
                localStorage.setItem('bmsOptions', parsed)
            },
            deep: true,
        },
        paginationOptions: {
            handler(newSearch) {
                this.buscar()
                const parsed = JSON.stringify(newSearch)
                localStorage.setItem('bmPaginationOptions', parsed)
            },
            deep: true,
        }
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        ...mapGetters(["bms", "checkUsers", "bmPagination"])
    },
};
</script>
